<template>
	<div class="layout">
		<div class="div-title">
			<div class="div-title-label">
				基本信息
			</div>
		</div>
		<div class="div-content">
			<div class="div-content-left">
				<ImagePage :imageData='packageData.imgFile'></ImagePage>
			</div>
			<div class="div-content-right">
				<div class="div-content-right-col">
					<div class="div-content-right-col-cell">
						套餐条码：<span class="div-content-right-col-cell-span">{{packageData.code}}</span>
					</div>
					<div class="div-content-right-col-cell">
						折扣（%）：<span class="div-content-right-col-cell-span">{{packageData.discount}}</span>
					</div>
					<div class="div-content-right-col-cell">
						计量单位：<span class="div-content-right-col-cell-span">{{packageData.unit}}</span>
					</div>
					<div class="div-content-right-col-cell">
						销售价格：<span class="div-content-right-col-cell-span">{{packageData.outPrice}}</span>
					</div>
					<div class="div-content-right-col-cell">
						采购合计：<span class="div-content-right-col-cell-span">{{packageData.purchaseAmount}}</span>
					</div>
				</div>
				<div class="div-content-right-col">
					<div class="div-content-right-col-cell">
						套餐名称：<span class="div-content-right-col-cell-span">{{packageData.name}}</span>
					</div>
					<div class="div-content-right-col-cell">
						套餐种类：<span class="div-content-right-col-cell-span">{{packageData.type}}</span>
					</div>
					<div class="div-content-right-col-cell">
						采购价格：<span class="div-content-right-col-cell-span">{{packageData.intoPrice}}</span>
					</div>
					<div class="div-content-right-col-cell">
						销售合计：<span class="div-content-right-col-cell-span">{{packageData.salesAmount}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="div-title">
			<div class="div-title-label">
				套餐详情
			</div>
		</div>
		<div class="div-content">
			<Table :columns="commodityColumn" :data="packageData.commodityPackageDetailInfos"></Table>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import ImagePage from '@/components/ImagePage'
	export default {
		name: 'packagedetailinfo',
		components: {
			ImagePage
		},
		data() {
			return {
				packageId: 0,
				packageData: {
					id: 0,
					code: '',
					name: '',
					unit: '',
					type: '',
					commodityPackageDetailInfos: [],
					discount: 100,
					purchaseAmount: 0,
					salesAmount:0,
					intoPrice: 0,
					outPrice: 0,
					isUse: true,
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					imgFile: []
				},
				commodityColumn: [
					{
					    title: '商品',
					    key: 'name',
				        fixed: 'left',
				        width: 300
					},
				    {
				        title: '单位',
				        key: 'unit',
				        width: 130
				    },
				    {
				        title: '规格',
				        key: 'format',
				        width: 140,
				    },
				    {
				        title: '当前库存',
				        key: 'stock',
				        width: 140,
				    },
				    {
				        title: '数量',
				        key: 'quantity',
				        width: 130
				    },
				    {
				        title: '采购单价',
				        key: 'purchasePrice',
				        width: 140
				    },
				    {
				        title: '销售单价',
				        key: 'salesPrice',
				        width: 140
				    },
				    {
				        title: '折扣(%)',
				        key: 'discount',
				        width: 140
				    },
				    {
				        title: '折后采购单价',
				        key: 'purchasePriceAfterDiscount',
				        width: 140
				    },
				    {
				        title: '折后销售单价',
				        key: 'salesPriceAfterDiscount',
				        width: 140
				    },
				    {
				        title: '采购总金额',
				        key: 'purchaseAmount',
				        width: 200
				    },
				    {
				        title: '销售总金额',
				        key: 'salesAmount',
				        width: 200
				    },
				    {
				        title: '备注',
				        key: 'note',
				        width: 350,
				    }
				]
			}
		},
		methods: {
			initPackageInfo(id) {
				let self = this;
				request.get('/api/CommodityPackage/GetCommodityPackage', {
					params: {
						id: id
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取套餐数据失败：" + response.errorMsg
						});
						return;
					}
					self.packageData = response.data;
				}).catch(function(error) {})
			}
		},
		watch: {
			'$route.query.packageId':{
				immediate: true,
				handler(param) {
					if(param){
						this.initPackageInfo(param);
					}
				}
			}
		},
		created: function() {
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		padding: 5px 10px;
	}

	.div-title {
		padding: 10px 0px;
		border-bottom: 1px solid #ebeef5;
	}

	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}

	.div-content {
		overflow: hidden;
		padding-top: 20px;
		margin-bottom: 20px;
	}

	.div-content-left {
		float: left;
		width: 30%;
	}

	.div-content-left-image {
		margin-top: 20px;
	}

	.div-content-left-image img {
		width: 300px;
		height: 300px;
	}

	.div-content-left-image-index {
		overflow: hidden;
		width: 300px;
	}

	.div-content-left-image-index-left {
		float: left;
		width: 6%;
		display: flex;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 45px;
		cursor: pointer;
	}

	.div-content-left-image-index-left:hover {
		border: rgb(255, 106, 127) 1px solid;
		color: rgb(255, 106, 127);
	}

	.div-content-left-image-index-center {
		float: left;
		width: 88%;
		overflow-y: auto;
		padding: 0px 4px;
	}

	.div-content-left-image-index-center img {
		width: 44px;
		height: 44px;
		cursor: pointer;
		margin-right: 4px;
	}

	.selected-image {
		border: rgb(255, 106, 127) 1px solid;
	}

	.div-content-left-image-index-right {
		float: right;
		width: 6%;
		display: flex;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 45px;
		cursor: pointer;
	}

	.div-content-left-image-index-right:hover {
		border: rgb(255, 106, 127) 1px solid;
		color: rgb(255, 106, 127);
	}

	.div-content-right {
		float: left;
		width: 70%;
		overflow: hidden;
	}

	.div-content-right-col {
		float: left;
		width: 50%;
	}

	.div-content-right-col-cell {
		padding: 15px;
	}
	
	.div-content-right-col-cell-span{
		color: black;
	}
</style>